import * as HicapsConnect from './hicaps-connect';
import * as HicapsConnectExtended from './hicaps-connect-extended';
export * from './hicaps-connect-response-codes';
export { HicapsConnect, HicapsConnectExtended };
